import { useEffect, useState } from 'react';
import { getReleaseIdentity, getSession, type PortalReleaseIdentity } from '../api';
import { useAuth } from '../auth';
import { PORTAL_RELEASE } from '../release';

export function SettingsPage() {
  const { user } = useAuth();
  const [actorId, setActorId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [identity, setIdentity] = useState<PortalReleaseIdentity | null>(null);

  useEffect(() => {
    let cancelled = false;
    void getSession()
      .then((result) => { if (!cancelled) setActorId(result.data.actorId); })
      .catch((caught: unknown) => { if (!cancelled) setError(caught instanceof Error ? caught.message : 'Could not load the portal session.'); });
    void getReleaseIdentity()
      .then((result) => { if (!cancelled) setIdentity(result.data); })
      .catch(() => undefined);
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <p className="eyebrow">Account</p>
      <h1>Settings</h1>
      <article className="card">
        <h2>Signed in</h2>
        <p>{user?.email ?? 'PackProof user'}</p>
        <p className="hash">{actorId ?? 'Resolving portal actor…'}</p>
        {error ? <p className="error">{error}</p> : null}
      </article>
      <article className="card">
        <h2>This browser is not a capture device</h2>
        <p>The portal reviews PackProofs, Proofs, and activity. Evidence acquisition stays on the native PackProof client in this release.</p>
      </article>
      <details className="card">
        <summary>Diagnostics</summary>
        <p className="meta">Hidden operator identity. This is not a launch claim.</p>
        <p className="hash">Portal source {PORTAL_RELEASE.productVersion} {PORTAL_RELEASE.gitSha}</p>
        <p className="hash">Portal built {PORTAL_RELEASE.builtAt}</p>
        <p className="hash">App {identity?.productVersion ?? 'unknown'}</p>
        <p className="hash">Backend {identity?.gitSha ?? 'unknown'}</p>
        <p className="hash">Environment {identity?.environment ?? 'unknown'}</p>
        <p className="hash">Deployed {identity?.deployedAt ?? 'not recorded'}</p>
      </details>
    </>
  );
}
